import { Box, lighten, styled } from '@mui/material';

export const ContractsGraphSection = styled(Box)(() => ({
  height: '100%',
  borderRadius: '5px 5px 0px 0px',
  backgroundColor: '#FFF',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
}));

export const GraphButtonContainer = styled(Box)(() => ({
  height: '30%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'center',
}));

export const GraphDisplayContainer = styled(Box)(() => ({
  height: '50%',
}));

export const GraphTitle = styled(Box)(({ theme }) => ({
  height: '20%',
  display: 'flex',
  borderRadius: '5px 5px 0px 0px',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 15px',
  color: '#fff',
  backgroundColor: lighten(theme.palette.primary.main, 0.4),
}));

export const ContractsSideLeftColumnStyled = styled(Box)(({ theme }) => ({
  minWidth: '200px',
  position: 'relative',
  [theme.breakpoints.down(600)]: {
    display: 'none',
  },
}));

export const ContractsSideRightColumnStyled = styled(Box)(({ theme }) => ({
  minWidth: '200px',
  position: 'relative',
  [theme.breakpoints.down(600)]: {
    display: 'none',
  },
}));

export const DashboardContractCardsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-evenly',
  padding: '10px',
  overflow: 'hidden',
});

export const DashboardContractsDateContainer = styled(Box)(() => ({
  display: 'flex',
  padding: '10px',
  justifyContent: 'space-between',
}));

export const DashboardContractsDayOfWeek = styled(Box)(() => ({
  paddingRight: '6px',
  fontWeight: 'bold',
}));

export const DashboardContractsTileStyled = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  color: '#303C42',
  padding: '10px',
  fontSize: '16px',
  backgroundColor: '#FFFFFF',
}));

export const DashboardLocationDropdownContainer = styled(Box)(() => ({
  width: '50%',
  margin: '0px auto',
}));

export const GridColumnStyled = styled(Box)({
  minWidth: '200px',
  position: 'relative',
  width: '33%',
  overflow: 'auto',
});

export const SideGridColumnStyled = styled(Box)({
  width: '100%',
  overflow: 'auto',
});

export const GradientColumnStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  overflow: 'auto',
  position: 'absolute',
  zIndex: '1',
  cursor: 'pointer',
  [theme.breakpoints.down(600)]: {
    width: '50%',
  },
}));

export const RightGradientColumnStyled = styled(GradientColumnStyled)(() => ({
  backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1))',
}));

export const LeftGradientColumnStyled = styled(GradientColumnStyled)(() => ({
  backgroundImage: 'linear-gradient(to left, rgba(255,255,255,0), rgba(255,255,255,1))',
  position: 'absolute',
  top: '0',
  right: '0',
}));

export const NumberOfItems = styled(Box)(() => ({
  width: '32px',
  height: '20px',
  background: '#71B790',
  borderRadius: '16px',
  color: 'white',
  textAlign: 'center',
  fontSize: '12px',
  lineHeight: '20px',
  marginTop: '1px',
  marginLeft: '5px',
}));
